var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
import colStyles from './ColStyles';
import { BreakpointsConsumer } from './BreakpointsProvider';
import { devMessage, isDevEnv } from './helpers/devMessage';
import { injectTestId } from '@cvent/nucleus-test-automation';
import { isObject } from '@cvent/carina-utils';
var Col = /** @class */ (function (_super) {
    __extends(Col, _super);
    function Col() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        // remove props we don't want to drop
        _this.cleanProps = function () {
            var _a = _this.props, _width = _a.width, _minWidth = _a.minWidth, _offset = _a.offset, _offsetEnd = _a.offsetEnd, _padding = _a.padding, _flex = _a.flex, _children = _a.children, _isRtl = _a.isRtl, _s = _a.s, _m = _a.m, _l = _a.l, _xl = _a.xl, _zIndex = _a.zIndex, restProps = __rest(_a, ["width", "minWidth", "offset", "offsetEnd", "padding", "flex", "children", "isRtl", "s", "m", "l", "xl", "zIndex"]);
            return restProps;
        };
        _this.checkProps = function () {
            isDevEnv(function () {
                var _a = _this.props, defaultPadding = _a.padding, s = _a.s, m = _a.m, l = _a.l, xl = _a.xl, id = _a.id;
                function checkForInvalidProperties(padding) {
                    if (isObject(padding)) {
                        Object.keys(padding).forEach(function (key) {
                            return ![
                                'start',
                                'paddingStart',
                                'end',
                                'paddingEnd',
                                'top',
                                'paddingTop',
                                'bottom',
                                'paddingBottom'
                            ].includes(key) &&
                                devMessage("[Col] Padding prop received a property named \"" + key + "\" (padding value: " + padding + "). \n                \nThis property will be ignored. \n                \nValid padding properties are 'start', 'end', 'top', and 'bottom'. " + (id ? "\nReported by Col with id=\"" + id + "\"" : ''));
                        });
                    }
                }
                return [
                    defaultPadding,
                    s === null || s === void 0 ? void 0 : s.padding,
                    m === null || m === void 0 ? void 0 : m.padding,
                    l === null || l === void 0 ? void 0 : l.padding,
                    xl === null || xl === void 0 ? void 0 : xl.padding
                ].forEach(function (property) {
                    return property !== undefined && checkForInvalidProperties(property);
                });
            });
        };
        return _this;
    }
    Col.prototype.render = function () {
        var _this = this;
        var props = this.props;
        return (_jsx(BreakpointsConsumer, { children: function (_a) {
                var s = _a.s, m = _a.m, l = _a.l, xl = _a.xl;
                var styles = colStyles({
                    zIndex: props === null || props === void 0 ? void 0 : props.zIndex,
                    breakpoints: {
                        s: s + 'px',
                        m: m + 'px',
                        l: l + 'px',
                        xl: xl + 'px'
                    },
                    componentDefaults: {
                        width: props.width,
                        minWidth: props.minWidth,
                        offset: props.offset,
                        offsetEnd: props.offsetEnd,
                        padding: props.padding,
                        flex: props.flex
                    },
                    s: props.s,
                    m: props.m,
                    l: props.l,
                    xl: props.xl,
                    isRtl: props.isRtl
                });
                return (_jsx("div", __assign({}, _this.cleanProps(), injectTestId(props.testID), { css: styles, "data-layout": "col" }, { children: props.children }), void 0));
            } }, void 0));
    };
    Col.prototype.componentDidMount = function () {
        this.checkProps();
    };
    Col.prototype.componentDidUpdate = function () {
        this.checkProps();
    };
    Col.defaultProps = {
        width: 1,
        minWidth: 0,
        offset: 0,
        offsetEnd: 0,
        // padding is set dynamically because responsive
        flex: {},
        s: {},
        m: {},
        l: {},
        xl: {}
    };
    return Col;
}(React.Component));
export default Col;
